import { A4uInfoOutline as IconComponent } from '@adobe/react-spectrum-workflow/dist/InfoOutline.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function InfoOutline(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}